import { gql } from '@/clients/utoniq-core'

export const fragments = {
  purchasablePrepaidPoints: gql`
    fragment PurchasablePrepaidPointConnection on PageResult {
      edges {
        node {
          ...PurchasablePrepaidPointDetail
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    fragment PrepaidPointsPaymentSource on CreditCard {
      id
      last4
      brand
    }
    fragment PurchasablePrepaidPointDetail on PurchasablePrepaidPoint {
      id
      points
      price
      description
      prepaidPointId
      metadata {
        id
        platform
      }
    }
  `,
  prepaidPointTransaction: gql`
    fragment PrepaidPointChargeResult on PrepaidPointTransaction {
      id
      prepaidPointBalance
      prepaidPointBalanceBefore
      transactionPrepaidPoint
      prepaidPointId
      expiredPrepaidPoint
      type
      createdAt
      formattedCreatedAt @client
    }
  `,
} as const
